const CF_LOCALE = "en-AU"
const localeRootPaths = ["/en", "/nz", "/uk", "/us"]

const getLangAttribute = pathname => {
    const urlLocale = pathname.split("/")[1]
    switch (urlLocale) {
        case "en":
            return "en-AU"
        case "nz":
            return "en-NZ"
        case "uk":
            return "en-GB"
        case "us":
            return "en-US"
        default:
            return "en-AU"
    }
}

const getUrlLocale = locale => {
    switch (locale) {
        case "en-AU":
            return "en"
        case "en-NZ":
            return "nz"
        case "en-GB":
            return "uk"
        case "en-US":
            return "us"
        default:
            return ""
    }
}

const isLocaleRootPath = pathname => {
    const normalizedPath = pathname?.replace(/\/+$/, "") || ""
    return localeRootPaths.includes(normalizedPath)
}

const getProductUrl = product => {
    switch (product.locale) {
        case "en-AU":
        case "en-NZ":
        case "en-GB":
        case "en-US":
            return `/${getUrlLocale(product.locale)}/${product.brandSlug}/products/${product["seo_page_name"]}`
        default:
            return `/product/${product["seo_page_name"]}`
    }
}

module.exports = { CF_LOCALE, getLangAttribute, getUrlLocale, isLocaleRootPath, getProductUrl }
